import script from "./CreditsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditsSlider.vue?vue&type=script&setup=true&lang=js"

import "./CreditsSlider.vue?vue&type=style&index=0&id=d041f4a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d041f4a6"]])

export default __exports__